import { createBrowserRouter } from 'react-router-dom';


import ProductWarranty from './ProductWarranty';
import CheckWarranty from './CheckWarranty';
import CheckWarrantyShort from './CheckWarrantyShort';
import WarrantySalaman from './WarrantySalaman';
import WarrantyVtech from './WarrantyVtech';
import Page404 from './404Error';
import Fallback from './Fallback';
import WarrantyInfo from './WarrantyInfo';

const router = createBrowserRouter([
  // Auth,
  //Main,
  ProductWarranty,
  CheckWarranty,
  CheckWarrantyShort,
  WarrantySalaman,
  WarrantyVtech,
  WarrantyInfo,
  Page404,
  Fallback
]);

export default router;
